var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRipple = function SvgRipple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.199,
    cy: 12.534,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.148 6.534h2.025l-4.213 4.315a3.84 3.84 0 0 1-5.522 0L5.225 6.534H7.25l3.2 3.278c.966.99 2.532.99 3.498 0l3.2-3.278ZM7.224 18.534H5.199l4.239-4.342a3.84 3.84 0 0 1 5.522 0l4.239 4.342h-2.025l-3.226-3.305a2.432 2.432 0 0 0-3.498 0l-3.226 3.305Z",
    fill: "#171C21"
  })));
};

export default SvgRipple;